class CustomProductGallery {
  constructor() {
    this.modal = null;
    this.currentIndex = 0;
    this.images = [];
    this.zoomLevel = 1;
    
    this.isDragging = false;
    this.hasDragged = false;
    this.startX = 0;
    this.startY = 0;
    this.translateX = 0;
    this.translateY = 0;
    
    this.init();
  }

  init() {
    // ÖNCE Dawn'ın orijinal zoom sistemini tamamen devre dışı bırak
    this.disableDawnZoom();
    
    this.images = Array.from(document.querySelectorAll('.product__media img, .product__media-item img'))
      .map(img => ({
        src: img.src.replace(/_\d+x\d+/, ''),
        alt: img.alt
      }))
      .filter((img, index, self) => 
        index === self.findIndex((t) => t.src === img.src)
      );

    if (this.images.length === 0) return;
    this.setupGallery();
  }

  // ============================================
  // DAWN'IN ORİJİNAL ZOOM SİSTEMİNİ KAPAT
  // ============================================
  disableDawnZoom() {
    // 1. Tüm toggle butonlarını devre dışı bırak
    document.querySelectorAll('.product__media-toggle').forEach(toggle => {
      toggle.style.pointerEvents = 'none';
      toggle.style.display = 'none';
    });
    
    // 2. Fotoğrafların tıklama olaylarını engelle
    document.querySelectorAll('.product__media-item, .product__media, .media-wrapper').forEach(item => {
      const clone = item.cloneNode(true);
      item.parentNode.replaceChild(clone, item);
    });
    
    // 3. Yeni klonlanmış elementlere kendi olaylarımızı ekle
    document.querySelectorAll('.product__media-item, .product__media, .media-wrapper').forEach((item, index) => {
      item.style.cursor = 'zoom-in';
      item.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.openGallery(index);
      });
    });
    
    // 4. Dawn'ın modal'ını bul ve kaldır
    const observer = new MutationObserver((mutations) => {
      document.querySelectorAll('.product-media-modal, [role="dialog"]').forEach(modal => {
        modal.remove();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    
    // 5. Şu anki modal'ları temizle
    document.querySelectorAll('.product-media-modal, [role="dialog"]').forEach(modal => {
      modal.remove();
    });
  }

  setupGallery() {
    const modalHTML = `
      <div id="custom-gallery-modal" style="display:none; position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.95); z-index:99999; overflow:hidden;">
        
        <button class="gallery-close" style="position:absolute; top:15px; right:15px; background:rgba(0,0,0,0.5); border:none; color:white; font-size:28px; cursor:pointer; z-index:100; width:44px; height:44px; border-radius:50%; display:flex; align-items:center; justify-content:center;">&times;</button>
        
        <button class="gallery-prev" style="position:absolute; left:10px; top:50%; transform:translateY(-50%); background:rgba(255,255,255,0.2); border:none; color:white; font-size:20px; padding:12px; cursor:pointer; border-radius:50%; z-index:100;">&#10094;</button>
        <button class="gallery-next" style="position:absolute; right:10px; top:50%; transform:translateY(-50%); background:rgba(255,255,255,0.2); border:none; color:white; font-size:20px; padding:12px; cursor:pointer; border-radius:50%; z-index:100;">&#10095;</button>
        
        <div class="gallery-image-container" style="width:100%; height:100%; display:flex; align-items:center; justify-content:center; position:relative; overflow:hidden;">
          <img class="gallery-image" src="" alt="" style="max-width:95%; max-height:85%; object-fit:contain; transition:transform 0.2s ease; cursor:zoom-in; user-select:none; -webkit-user-drag:none; touch-action:none;">
        </div>
        
        <div class="gallery-thumbnails" style="position:absolute; bottom:15px; left:50%; transform:translateX(-50%); display:flex; gap:8px; z-index:100; background:rgba(0,0,0,0.6); padding:8px; border-radius:8px; max-width:95%; overflow-x:auto;">
          ${this.images.map((img, i) => `
            <img src="${img.src}" data-index="${i}" style="width:50px; height:50px; object-fit:cover; border:2px solid ${i === 0 ? '#fff' : 'transparent'}; cursor:pointer; border-radius:4px; flex-shrink:0;">
          `).join('')}
        </div>
        
        <div class="gallery-counter" style="position:absolute; top:15px; left:50%; transform:translateX(-50%); color:white; font-size:13px; background:rgba(0,0,0,0.6); padding:4px 12px; border-radius:20px; z-index:100;">1 / ${this.images.length}</div>
      </div>
    `;
    
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    
    this.modal = document.getElementById('custom-gallery-modal');
    this.imageEl = this.modal.querySelector('.gallery-image');
    this.counterEl = this.modal.querySelector('.gallery-counter');
    this.thumbnailsEl = this.modal.querySelector('.gallery-thumbnails');
    
    this.bindEvents();
  }

  bindEvents() {
    // Kapatma
    this.modal.querySelector('.gallery-close').addEventListener('click', () => this.close());
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.close();
    });
    
    // Önceki/sonraki
    this.modal.querySelector('.gallery-prev').addEventListener('click', (e) => {
      e.stopPropagation();
      this.prev();
    });
    this.modal.querySelector('.gallery-next').addEventListener('click', (e) => {
      e.stopPropagation();
      this.next();
    });
    
    // Klavye
    document.addEventListener('keydown', (e) => {
      if (!this.modal.style.display || this.modal.style.display === 'none') return;
      if (e.key === 'Escape') this.close();
      if (e.key === 'ArrowLeft') this.prev();
      if (e.key === 'ArrowRight') this.next();
    });
    
    // CLICK - Zoom aç/kapat
    this.imageEl.addEventListener('click', (e) => {
      if (this.hasDragged) {
        this.hasDragged = false;
        return;
      }
      
      if (this.zoomLevel === 1) {
        this.zoomIn(e);
      } else {
        this.zoomOut();
      }
    });
    
    // PAN - Mouse
    this.imageEl.addEventListener('mousedown', (e) => {
      if (this.zoomLevel === 1) return;
      this.isDragging = true;
      this.hasDragged = false;
      this.startX = e.clientX - this.translateX;
      this.startY = e.clientY - this.translateY;
      this.imageEl.style.transition = 'none';
      this.imageEl.style.cursor = 'grabbing';
    });
    
    document.addEventListener('mousemove', (e) => {
      if (!this.isDragging || this.zoomLevel === 1) return;
      
      const newX = e.clientX - this.startX;
      const newY = e.clientY - this.startY;
      
      if (Math.abs(newX - this.translateX) > 3 || Math.abs(newY - this.translateY) > 3) {
        this.hasDragged = true;
      }
      
      this.translateX = newX;
      this.translateY = newY;
      this.limitPan();
      this.updateTransform();
    });
    
    document.addEventListener('mouseup', () => {
      this.isDragging = false;
      if (this.zoomLevel > 1) {
        this.imageEl.style.cursor = 'grab';
      }
    });
    
    // PAN - Touch
    this.imageEl.addEventListener('touchstart', (e) => {
      if (this.zoomLevel === 1) return;
      this.isDragging = true;
      this.hasDragged = false;
      const touch = e.touches[0];
      this.startX = touch.clientX - this.translateX;
      this.startY = touch.clientY - this.translateY;
      this.imageEl.style.transition = 'none';
    }, { passive: false });
    
    document.addEventListener('touchmove', (e) => {
      if (!this.isDragging || this.zoomLevel === 1) return;
      e.preventDefault();
      
      const touch = e.touches[0];
      const newX = touch.clientX - this.startX;
      const newY = touch.clientY - this.startY;
      
      if (Math.abs(newX - this.translateX) > 3 || Math.abs(newY - this.translateY) > 3) {
        this.hasDragged = true;
      }
      
      this.translateX = newX;
      this.translateY = newY;
      this.limitPan();
      this.updateTransform();
    }, { passive: false });
    
    document.addEventListener('touchend', () => {
      this.isDragging = false;
    });
    
    // Swipe (fotoğraf geçişi)
    let touchStartX = 0;
    this.modal.addEventListener('touchstart', (e) => {
      if (this.zoomLevel === 1) {
        touchStartX = e.touches[0].clientX;
      }
    });
    this.modal.addEventListener('touchend', (e) => {
      if (this.zoomLevel === 1) {
        const touchEndX = e.changedTouches[0].clientX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
          diff > 0 ? this.next() : this.prev();
        }
      }
    });
    
    // Thumbnail
    this.thumbnailsEl.addEventListener('click', (e) => {
      if (e.target.tagName === 'IMG') {
        this.goToImage(parseInt(e.target.dataset.index));
      }
    });
  }

  limitPan() {
    const rect = this.imageEl.getBoundingClientRect();
    const containerRect = this.imageEl.parentElement.getBoundingClientRect();
    
    const maxX = Math.max(0, (rect.width * this.zoomLevel - containerRect.width) / 2);
    const maxY = Math.max(0, (rect.height * this.zoomLevel - containerRect.height) / 2);
    
    this.translateX = Math.max(-maxX, Math.min(maxX, this.translateX));
    this.translateY = Math.max(-maxY, Math.min(maxY, this.translateY));
  }

  zoomIn(e) {
    this.zoomLevel = 2.5;
    this.imageEl.style.cursor = 'grab';
    
    const rect = this.imageEl.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;
    this.translateX = -x * 1.5;
    this.translateY = -y * 1.5;
    
    this.limitPan();
    this.updateTransform();
  }

  zoomOut() {
    this.zoomLevel = 1;
    this.translateX = 0;
    this.translateY = 0;
    this.imageEl.style.cursor = 'zoom-in';
    this.updateTransform();
  }

  resetAll() {
    this.zoomLevel = 1;
    this.translateX = 0;
    this.translateY = 0;
    this.isDragging = false;
    this.hasDragged = false;
    this.imageEl.style.transition = 'transform 0.2s ease';
    this.imageEl.style.cursor = 'zoom-in';
    this.updateTransform();
  }

  // ============================================
  // ANA SAYFADAKİ TÜM FOTOĞRAFLARI TAMİR ET
  // ============================================
  fixPageImages() {
    // Tüm ürün fotoğraflarını bul ve düzelt
    const selectors = [
      '.product__media img',
      '.product__media-item img', 
      '.media img',
      '.product-media img',
      '.product__media-wrapper img',
      '.product-media-container img',
      '[data-media-id] img'
    ];
    
    selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(img => {
        // Transform'u temizle
        img.style.transform = 'none';
        img.style.transform = '';
        img.removeAttribute('style');
        
        // Transform ile ilgili tüm CSS değişkenlerini temizle
        img.style.setProperty('transform', 'none', 'important');
        
        // Parent'ları da temizle
        let parent = img.parentElement;
        for (let i = 0; i < 5 && parent; i++) {
          parent.style.transform = '';
          parent.style.transition = '';
          parent = parent.parentElement;
        }
      });
    });
    
    // Dawn'ın zoom state'ini sıfırla
    document.querySelectorAll('.product__media-item, .product__media').forEach(el => {
      el.classList.remove('is-active', 'is-zoomed');
    });
  }

  openGallery(index) {
    this.currentIndex = Math.min(index, this.images.length - 1);
    this.resetAll();
    this.updateImage();
    this.modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.modal.style.display = 'none';
    document.body.style.overflow = '';
    this.resetAll();
    
    // ANA SAYFAYI DÜZELT
    this.fixPageImages();
    
    // Tekrar tekrar düzelt (Dawn'ın JS'i sonradan müdahale edebilir)
    setTimeout(() => this.fixPageImages(), 50);
    setTimeout(() => this.fixPageImages(), 150);
    setTimeout(() => this.fixPageImages(), 300);
    setTimeout(() => this.fixPageImages(), 500);
  }

  updateImage() {
    const img = this.images[this.currentIndex];
    this.resetAll();
    this.imageEl.src = img.src;
    this.imageEl.alt = img.alt;
    this.counterEl.textContent = `${this.currentIndex + 1} / ${this.images.length}`;
    
    this.thumbnailsEl.querySelectorAll('img').forEach((thumb, i) => {
      thumb.style.borderColor = i === this.currentIndex ? '#fff' : 'transparent';
    });
  }

  updateTransform() {
    this.imageEl.style.transform = `translate(${this.translateX}px, ${this.translateY}px) scale(${this.zoomLevel})`;
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
    this.updateImage();
  }

  prev() {
    this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
    this.updateImage();
  }

  goToImage(index) {
    this.currentIndex = index;
    this.updateImage();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CustomProductGallery();
}); // ============================================
// SEPET BOŞKEN YÖNLENDİRME
// ============================================

document.addEventListener('DOMContentLoaded', () => {
  const cartBtn = document.getElementById('cart-icon-bubble');
  
  if (!cartBtn) return;
  
  // Orijinal tıklamayı engelle
  cartBtn.addEventListener('click', (e) => {
    // Sepet boş mu kontrol et
    const cartCount = document.querySelector('.cart-count-bubble');
    const hasItems = cartCount && cartCount.textContent.trim() !== '' && parseInt(cartCount.textContent.trim()) > 0;
    
    if (!hasItems) {
      // Boşsa /cart sayfasına git
      e.preventDefault();
      e.stopPropagation();
      window.location.href = '/cart';
    }
    // Doluysa normal davran (modal aç)
  }, true); // capture phase
});